﻿import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import { FETCH_INCIDENTS_SUCCESS, INITIAL_INCIDENTS_REQUEST } from "@/redux/types/maintainers/incidents.type";

import Head from "@/components/Content/Head";
import classes from "../maintainers.module.scss";

import api from "@/services/api.service";

import BasePagination from "@/components/Pagination/BasePagination";
import Fetching from "@/components/Fetching/Fetching";
import BasicConfirm from "@/components/Confirm/BasicConfirm";
import IncidentsTableHead from "./IncidentsTableHead";
import IncidentsTableBody from "./IncidentsTableBody";
import IncidentsForm from "./IncidentsForm/IncidentsForm";
import { toast } from "@/services/Utils";
import IncidentsView from "./IncidentsForm/IncidentsView";

const Incidents = () => {
	const dispatch = useDispatch();
	const { addToast } = useToasts();
	const navigate = useNavigate();

	const { search } = useSelector((state) => state.auth.filter);
	const { isFetching, quantity, last_page, from, to, customers } = useSelector((state) => state.maintainers_incidents);

	const [selected, setSelected] = useState("");
	const [paginate, setPaginate] = useState(10);
	const [page, setPage] = useState(1);
	const [order, setOrder] = useState("creation_date");
	const [orderType, setOrderType] = useState("desc");
	const [loaded, setLoaded] = useState(false);
	// const [showFilter, setShowFilter] = useState(false);

	const [showDelete, setShowDelete] = useState(false);

	useEffect(() => {
		dispatch({ type: INITIAL_INCIDENTS_REQUEST });
		api.get("/admin/incidents", {
			page,
			paginate,
			order,
			orderType,
			search,
		}).then((response) => {
			updateData(response);
		});
		// eslint-disable-next-line
	}, [search, order, orderType, paginate, page]);

	const updateData = (response) => {
		if (Object.prototype.hasOwnProperty.call(response, "incidents")) {
			const { customers, incidents } = response;
			dispatch({
				type: FETCH_INCIDENTS_SUCCESS,
				payload: {
					incidents: incidents.data,
					last_page: incidents.last_page,
					from: incidents.from,
					to: incidents.to,
					quantity: incidents.total,
					customers: customers,
				},
			});
			setLoaded(true);
		} else {
			setLoaded(true);
		}
	};

	const handleDelete = (item) => {
		setSelected(item.id);
		setShowDelete(true);
	};

	const confirmDelete = () => {
		setShowDelete(false);
		setSelected("");
		setPage(1);

		dispatch({ type: INITIAL_INCIDENTS_REQUEST });
		api.post("/admin/incidents/delete", {
			page,
			selected,
			paginate,
			order,
			orderType,
			search,
		}).then((response) => {
			toast(addToast, "Incidencia eliminada correctamente.", "success");
			updateData(response);
		});
	};

	const confirmSave = (form, modalFetching, afterSave) => {
		modalFetching(true);
		setPage(1);

		api.post("/admin/incidents/save", {
			...form.form,
			page,
			paginate,
			order,
			orderType,
			search,
		}).then((response) => {
			if (Object.prototype.hasOwnProperty.call(response, "incidents")) {
				updateData(response);
				modalFetching(false);
				afterSave();
			} else {
				modalFetching(false);
			}
		});
	};

	if (isFetching) {
		return <Fetching />;
	}

	return (
		<>
			<Head
				title="Incidencias"
				button={true}
				button_text={"Nueva Incidencia"}
				action={() => navigate("/mantenedores/incidencias/crear")}
				back_url={"/mantenedores"}
			/>

			<Row className={` ${classes.main_row}`}>
				<Col md={12} className={classes.main_col}>
					<Row className={classes.table}>
						<div className={classes.table_div}>
							<Table className={classes.table_desktop}>
								<IncidentsTableHead order={order} setOrder={setOrder} orderType={orderType} setOrderType={setOrderType} />

								<IncidentsTableBody handleDelete={handleDelete} />
							</Table>
						</div>
					</Row>

					<BasePagination
						page={page}
						paginate={paginate}
						last_page={last_page}
						quantity={quantity}
						from={from}
						to={to}
						setPage={setPage}
						setPaginate={setPaginate}
					/>
				</Col>
			</Row>

			{loaded && (
				<>
					<BasicConfirm showConfirm={showDelete} setShowConfirm={setShowDelete} handleAction={confirmDelete} />

					<IncidentsForm customers={customers} confirmSave={confirmSave} />

					<IncidentsView customers={customers} confirmSave={confirmSave} />
				</>
			)}
		</>
	);
};

export default Incidents;
